/**
 * Shopify Cart API 429 Handler
 * 
 * Problem: When cart API returns 429 (rate limited), the response is silent
 * and users cannot see the Shopify challenge page to verify themselves.
 * 
 * Solution: This script ONLY monitors cart API responses. When 429 is detected,
 * it redirects to /cart for Cloudflare verification, then returns to original page.
 * 
 * Note: This uses fetch interception, but ONLY processes cart API responses.
 * All other requests pass through unchanged with zero overhead.
 */

(function() {
  'use strict';

  // FIRST: Check if we need to return to original page after verification
  // Do this immediately before any rendering to avoid flash
  const returnUrl = sessionStorage.getItem('cart_429_return_url');
  if (returnUrl && location.pathname === '/cart') {
    sessionStorage.removeItem('cart_429_return_url');
    // Redirect immediately - no delay
    window.location.replace(returnUrl);
    return; // Stop script execution
  }

  // Skip if inside iframe
  if (window.self !== window.top) {
    return;
  }

  // Shopify cart API endpoints that may return 429
  const CART_ENDPOINTS = [
    '/cart.js',
    '/cart/add.js',
    '/cart/update.js',
    '/cart/change.js',
    '/cart/clear.js'
  ];

  const originalFetch = window.fetch;

  // Check if this is a cart API request
  function isCartAPI(url) {
    if (!url) return false;
    try {
      const pathname = new URL(url, location.origin).pathname;
      return CART_ENDPOINTS.includes(pathname);
    } catch {
      return false;
    }
  }

  // Wrap fetch - only process cart API 429 responses
  window.fetch = function(url, options) {
    const checkThis = isCartAPI(url);
    
    return originalFetch.call(this, url, options).then(response => {
      // Only act on cart API 429 responses
      if (checkThis && response.status === 429) {
        console.warn('[Cart 429] Rate limited, redirecting for verification...');
        // Save current page to return after verification
        sessionStorage.setItem('cart_429_return_url', location.href);
        // Redirect to cart page for Cloudflare verification
        window.location.href = '/cart';
      }
      return response;
    });
  };
})();